import { useMemo, useState } from "react";

import { DeploymentTable } from "../components/DeploymentTable.jsx";
import { PageHeader } from "../components/PageHeader.jsx";
import { EmptyState, Spinner } from "../components/ui.jsx";
import { api } from "../lib/api.js";
import { useLive } from "../lib/events.js";
import { useUrlStates } from "../lib/useUrlState.js";

/** Everything that has happened on the box, newest first. */
export function Deployments() {
    const [deployments, setDeployments] = useState(null);
    const [projects, setProjects] = useState([]);
    const [{ status }, setUrl] = useUrlStates({ status: "" });
    const setStatus = (value) => setUrl("status", value);

    useLive(["deployments"], () => api.deployments.list({ limit: 100 }).then(setDeployments).catch(() => setDeployments([])));
    useLive(["projects"], () => api.projects.list().then(setProjects).catch(() => {}));

    // Icons come from the project list; a deployment record carries no hash.
    const iconOf = useMemo(() => {
        const bySlug = new Map(projects.map((project) => [project.slug, project.favicon?.hash ?? null]));
        return (slug) => bySlug.get(slug) ?? null;
    }, [projects]);

    if (!deployments) return <Spinner className="muted" />;

    const shown = status ? deployments.filter((d) => d.status === status) : deployments;

    return (
        <>
            <PageHeader
                title="Deployments"
                meta={status ? `${shown.length} of ${deployments.length}` : `${deployments.length} deployments`}
                actions={
                    <select className="input w-full sm:w-44" value={status} onChange={(event) => setStatus(event.target.value)} aria-label="Filter by status">
                        <option value="">Any status</option>
                        {["success", "failed", "rolled-back", "running", "queued", "skipped"].map((value) => (
                            <option key={value} value={value}>{value}</option>
                        ))}
                    </select>
                }
            />

            <DeploymentTable
                deployments={shown}
                project
                iconOf={iconOf}
                caption="Deployments across all projects"
                empty={<div className="card"><EmptyState title="Nothing here yet" hint="Push to a project's branch, or deploy one by hand." /></div>}
            />
        </>
    );
}
